import enquire from 'enquire.js';
import Rellax from 'rellax';
import analyticsEvent from './analytics-event';


// const isProd = process.env.NODE_ENV === 'production';
// const meta = require('./meta.json');

// const romanize = num => {
//     if (!+num) {
//         return NaN;
//     }
//     const digits = String(+num).split('');
//     const key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
//         '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
//         '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];

//     let roman = '';
//     let i = 3;

//     while (i--) {
//         roman = (key[+digits.pop() + i * 10] || '') + roman;
//     }
//     return Array(+digits.join('') + 1).join('M') + roman;
// };

const root = document.getElementById('news-root');
const rellax = [];

const initNews = async () => {
    const jsonLink = (/wmj\.ru$/).test(window.location.host)
        ? 'https://www.wmj.ru/exports/rambler-crm/mbfwr-ss-2019'
        : 'https://stage2.wmj.ru/exports/rambler-crm/mbfwr-ss-2019';

    const request = await fetch(jsonLink);
    const news = await request.json();

    news.sort((a, b) => {
        const dateA = Date.parse(a.published_at);
        const dateB = Date.parse(b.published_at);
        return dateB - dateA;
    });

    const buildGrid = () => {
        if (!(root instanceof HTMLElement)) {
            return;
        }

        const buildItem = (item, index) => {
            const root = document.createElement('a');
            root.setAttribute('rel', 'noopener');
            root.setAttribute('href', item.link);
            root.setAttribute('target', '_blank');

            root.addEventListener('click', () => {
                analyticsEvent('News', 'open', `Link: ${item.link}`);
            });

            const finalIndex = (index + 1) % 6 || 6;
            const rootClass = 'news__item--' + finalIndex;
            root.classList.add('news__item');
            root.classList.add('rellax');
            root.classList.add(rootClass);
            if (item.tags.indexOf('glo') !== -1) {
                root.classList.add('news__item_glo');
            }

            switch (finalIndex) {
                case 1: root.dataset.rellaxSpeed = 2; break;
                case 2: root.dataset.rellaxSpeed = 6; break;
                case 3: root.dataset.rellaxSpeed = -2; break;
                case 4: root.dataset.rellaxSpeed = 1; break;
                case 5: root.dataset.rellaxSpeed = 4; break;
                case 6: root.dataset.rellaxSpeed = -2; break;
            }

            const pictureWrapper = document.createElement('div');
            pictureWrapper.classList.add('news__item__picture');

            const image = document.createElement('img');
            image.setAttribute('src', item.cover_url);

            pictureWrapper.appendChild(image);

            const timeWrapper = document.createElement('div');
            timeWrapper.classList.add('news__item__time');

            const date = new Date(item.published_at);
            const day = date.getDate();
            const month = date.getMonth() + 1;

            // timeWrapper.innerText = romanize(day) + '.' + romanize(month);
            timeWrapper.innerText = day + '.' + month;

            const contentWrapper = document.createElement('div');
            const contentWrapperRellax = document.createElement('div');
            contentWrapper.classList.add('news__item__content');
            contentWrapperRellax.classList.add('rellax');
            contentWrapperRellax.classList.add('news__item__content__wrapper');

            contentWrapperRellax.dataset.rellaxSpeed = 2;

            contentWrapperRellax.appendChild(contentWrapper);

            const header = document.createElement('h3');
            header.innerText = item.headline;

            contentWrapper.appendChild(header);

            root.appendChild(pictureWrapper);
            root.appendChild(timeWrapper);
            root.appendChild(contentWrapperRellax);
            return root;
        };


        while (root.firstChild) {
            root.removeChild(root.firstChild);
        }

        news.forEach((item, i) => {
            const newsItem = buildItem(item, i);
            root.appendChild(newsItem);
        });
    };

    buildGrid();
}

const destroyRellax = () => {
    if (!(root instanceof HTMLElement)) {
        return;
    }

    if (rellax.length > 0) {
        rellax.forEach(item => item.destroy());
        rellax.splice(0, rellax.length);

        const elements = root.querySelectorAll('.rellax');

        elements.forEach(element => {
            element.style.transform = 'none';
        });
    }

    if (typeof onRefresh !== 'undefined') {
        window.removeEventListener('refresh', onRefresh);
        onRefresh = void 0;
    }
};

let onRefresh;

 const initRellax = () => {
    if (!(root instanceof HTMLElement)) {
        return;
    }

    if (rellax.length > 0) {
        destroyRellax();
    }

    const elements = root.querySelectorAll('.rellax');

    elements.forEach(element => {
        rellax.push(new Rellax(element, {
            speed: -2,
            center: true,
            round: true,
            vertical: true,
            horizontal: false
        }));
    });

    onRefresh = () => {
        rellax.forEach(relx => {
            relx.refresh();
        });
    };

    window.addEventListener('refresh', onRefresh);
};


const init = async () => {
    await initNews();
    initRellax();
};

const destroy = () => {
    destroyRellax();
};

const initMobile = () => {
    initNews();
};

const destroyMobile = () => {

};

enquire.register('screen and (min-width:992px)', {
    match: init,
    unmatch: destroy
});

enquire.register('screen and (max-width:991px)', {
    match: initMobile,
    unmatch: destroyMobile
});



// WEBPACK FOOTER //
// ./js/news.js